import { FormDialogProps } from '../../components/FormDialog/types';
import AddButton from '../../components/Buttons/AddButton';
import EditButton from '../../components/Buttons/EditButton';
import AdditionalStageDialogContent from '../../components/AdditionalStageDialogContent/AdditionalStageDialogContent';
import AdditionalExerciseDialogContent from '../../components/AdditionalExerciseDialogContent/AdditionalExerciseDialogContent';

export const editAdditionalStageDialogParams = {
    buttonLabel: 'Edit',
    button: EditButton,
    leftBtnName: 'Save',
    rightBtnName: 'Publish',
    leftBtnType: 'submit',
    rightBtnType: 'button',
    publish: true,
    title: 'Edit additional mission',
    component: { item: AdditionalStageDialogContent, filedName: '' },
} as FormDialogProps;

export const additionalStageDialogParams = {
    buttonLabel: 'Add',
    button: AddButton,
    leftBtnName: 'Save',
    rightBtnName: 'Publish',
    leftBtnType: 'submit',
    rightBtnType: 'button',
    publish: true,
    title: 'Add additional mission',
    component: { item: AdditionalStageDialogContent, filedName: '' },
} as FormDialogProps;

export const additionalExercisesDialogParams = {
    buttonLabel: 'Add',
    button: AddButton,
    rightBtnName: 'Save',
    title: 'Add new lesson',
    component: { item: AdditionalExerciseDialogContent, filedName: '' },
} as FormDialogProps;

export const editAdditionalExercisesDialogParams = {
    buttonLabel: 'Edit',
    button: EditButton,
    rightBtnName: 'Save',
    title: 'Edit lesson',
    component: { item: AdditionalExerciseDialogContent, filedName: '' },
} as FormDialogProps;
